import { SubscriptionService } from "../services/subscription/subscription.service";
import {
  SubscriptionPlans,
  SubscriptionStates,
} from "@/domain/entities-new/subscription/subscription.entity";

type ConfigParams = {
  allowFreeTrial?: boolean;
};

async function hasActiveSubscription(config?: ConfigParams): Promise<boolean> {
  const { allowFreeTrial = true } = config || {};

  const subscription = await SubscriptionService.getUserSubscription();
  if (!subscription.ok) {
    return false;
  }
  if (
    subscription.value.plan === SubscriptionPlans.FreeTrial.Trainee &&
    !allowFreeTrial
  ) {
    return false;
  }

  return subscription.value.status === SubscriptionStates.Active;
}

export { hasActiveSubscription };
